import React, { useState, useRef, useEffect } from "react";
import { useDragableAndResizer } from "./hooks/useDragableAndResizer";

const DragableAndResizer = ({
  children = <>Teste</>,
  minWidthInPixel = 520,
  minHeightPercent = 70,
  signalToResetPosition = null,
  initialPositionX = 100,
  initialPositiony = 100,
}) => {
  const { handleMouseDownDrag, position, size } = useDragableAndResizer(
    initialPositionX,
    initialPositiony,
    signalToResetPosition,
    minWidthInPixel,
    minHeightPercent,
  );
  return (
    <div
      onMouseDown={handleMouseDownDrag}
      style={{
        minWidth: `${minWidthInPixel}px`,
        minHeight: `${minHeightPercent}dvh`,
        position: "absolute",
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: `${size.w}px`,
        height: `${size.h}px`,
        backgroundColor: "#ffffff",
        cursor: "move",
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        borderRadius: "8px",
        boxShadow:
          "0 1px 3px 0 rgba(60, 64, 67, .3), 0 4px 8px 3px rgba(60, 64, 67, .15)",
        zIndex: 999,
      }}
    >
      {children}

      {/* PUXADOR DE REDIMENSIONAMENTO (Canto Inferior Direito) */}
      {/* <div
        className="resizer"
        onMouseDown={handleMouseDownResize}
        style={{
          width: "15px",
          height: "15px",
          backgroundColor: "#ccc", // Mudei ligeiramente a cor para ser visível
          position: "absolute",
          right: "5px",
          bottom: "5px",
          borderRadius: "50%",
          cursor: "nwse-resize",
          zIndex: 10,
        }}
      /> */}
    </div>
  );
};

export default DragableAndResizer;
